import { render, staticRenderFns } from "./ReferentielProduitApproView.vue?vue&type=template&id=efe6ba12"
import script from "./ReferentielProduitApproView.vue?vue&type=script&lang=js"
export * from "./ReferentielProduitApproView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports